import React, { useState } from 'react';
import { FileText, Award, ClipboardCheck, GraduationCap, HeartPulse } from 'lucide-react';
import ACGMEMilestonesPage from './ACGMEMilestonesPage';
import { Section, Card } from '../hospital/shared/primitives';
import { LinkRow, IntroRow } from '../shared/ListRows';

const ACCENT = '#0369a1';
const base = process.env.PUBLIC_URL;

const POLICIES = [
  ['Residency handbook', 'Program policies and procedures', `${base}/anes-dept/residency-handbook.pdf`],
  ['Supervision policy', 'Resident supervision requirements', `${base}/anes-dept/supervision-policy.pdf`],
  ['Time off policy', 'Vacation, sick leave and requests', `${base}/anes-dept/pto-policy.pdf`],
  ['Substance abuse policy', 'Program policy and resources', `${base}/anes-dept/substance-abuse-policy.pdf`],
];
const POLICIES_PENDING = ['Professionalism policy', 'Conference attendance policy', 'Moonlighting policy'];

const BCMAnesthesiologyResidency = ({ onTeeClick }) => {
  const [milestones, setMilestones] = useState(false);
  if (milestones) return <ACGMEMilestonesPage onBack={() => setMilestones(false)} />;

  return (
    <div className="space-y-6">
      <Card>
        <IntroRow icon={GraduationCap} title="Residency program" accent={ACCENT}>
          Four years, six institutions, every subspecialty. Graduates are prepared for independent practice or fellowship.
        </IntroRow>
      </Card>

      <Section title="Policies and documents">
        <Card>
          {POLICIES.map(([t, s, h]) => <LinkRow key={t} icon={FileText} title={t} subtitle={s} href={h} accent={ACCENT} />)}
          {POLICIES_PENDING.map((t) => <LinkRow key={t} icon={FileText} title={t} subtitle="To be added" muted accent={ACCENT} />)}
        </Card>
      </Section>

      <Section title="Board preparation">
        <Card>
          <IntroRow icon={Award} accent={ACCENT}>The department provides TrueLearn for every resident, for the in-training examination and the written board.</IntroRow>
          <LinkRow title="TrueLearn" subtitle="Question bank, department funded" href="https://www.truelearn.com" />
        </Card>
      </Section>

      <Section title="Certification">
        <Card>
          <LinkRow icon={HeartPulse} title="Basic TEE certification" subtitle="NBE pathway, requirements and your case log" onClick={onTeeClick} accent={ACCENT} />
        </Card>
      </Section>

      <Section title="ACGME">
        <Card>
          <LinkRow icon={ClipboardCheck} title="ACGME Milestones" subtitle="The competencies residents are evaluated on, by level" onClick={() => setMilestones(true)} accent={ACCENT} />
          <LinkRow title="ACGME case logs" subtitle="Log cases online" href="https://www.acgme.org" />
          <LinkRow title="MedHub" subtitle="Duty hours and evaluations" href="https://www.medhub.com" />
        </Card>
      </Section>

      <Section title="Curriculum">
        <Card>
          <LinkRow title="CA-1 lecture schedule" subtitle="To be added" muted />
          <LinkRow title="CA-3 senior seminar schedule" subtitle="To be added" muted />
        </Card>
      </Section>
    </div>
  );
};

export default BCMAnesthesiologyResidency;
